import * as React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import { useState, useEffect } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { useLanguage } from "./Language";
import Stack from "@mui/material/Stack";
import { HigherContrastToggleButtonGroup } from "./ResultsViewToggle";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export const CONFIG_SEARCH = "configListType";
export const PERSONAL_SEARCH = "personalListType";

// TODO update to use ListType enum from ListService
export type SavedSearchTypeKey = "configListType" | "personalListType";

interface SavedSearchTypeToggleProps {
  value: SavedSearchTypeKey;
  personalCount: number;
  configCount: number;
  onChange?: (
    event: React.MouseEvent<HTMLElement>,
    newValue: SavedSearchTypeKey
  ) => void;
}

export const SavedSearchTypeToggle = ({
  value,
  configCount,
  personalCount,
  onChange,
}: SavedSearchTypeToggleProps) => {
  const { translate } = useLanguage();

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: SavedSearchTypeKey | null
  ) => {
    // don't allow deselection
    if (newValue != null) {
      if (onChange) {
        onChange(event, newValue);
      }
    }
  };

  return (
    <HigherContrastToggleButtonGroup
      color="secondary"
      value={value}
      onChange={handleChange}
      exclusive
      size="small"
      aria-label={translate("viewAs")}
    >
      <ToggleButton value={CONFIG_SEARCH} sx={{ pr: "12px", pl: "12px" }}>
        <Stack
          direction="row"
          spacing={{ xs: 1 }}
          useFlexGap
          sx={{
            alignItems: "center"
          }}
        >
          {value === CONFIG_SEARCH && <CheckIcon />}
          <Box>{translate("config")}</Box>
          {configCount === null ? (
            <Skeleton variant="text" sx={{ fontSize: "1rem", width: "1rem" }} />
          ) : (
            <Box>({configCount})</Box>
          )}
        </Stack>
      </ToggleButton>
      <ToggleButton value={PERSONAL_SEARCH} sx={{ pr: "12px", pl: "12px" }}>
        <Stack
          direction="row"
          spacing={{ xs: 1 }}
          useFlexGap
          sx={{
            alignItems: "center"
          }}
        >
          {value === PERSONAL_SEARCH && <CheckIcon />}
          <Box>{translate("personal")}</Box>
          {personalCount === null ? (
            <Skeleton variant="text" sx={{ fontSize: "1rem", width: "1rem" }} />
          ) : (
            <Box>({personalCount})</Box>
          )}
        </Stack>
      </ToggleButton>
    </HigherContrastToggleButtonGroup>
  );
};
